<template>
  <el-container class="moreDialog">
    <!-- 更多 -->
    <h-table
      ref="tableRef"
      v-model:columns="columns"
      :method="oftenOut"
      :params="tableParams"
    >
      <template #fileUrl="{ row }">
        <el-image
          v-if="row.fileUrl"
          class="table-img"
          style="height: 50px; width: 50px"
          :src="imgURL + row.fileUrl"
          :preview-src-list="[row.fileUrl && imgURL + row.fileUrl]"
        ></el-image>
      </template>
    </h-table>
  </el-container>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  inject
} from "vue";
import { queryUserList } from "@/api/realPopulation/realPopulation";
import {
  oftenOut
} from "@/api/publicSecurityResearch/drugControlModel.js";
export default defineComponent({
  name: "moreDialog",
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const state = reactive({
      imgURL: window.imgURL,
      tableParams: {
        endDate: "",
        startDate: "",
        followIds: [],
        libareIds: '',
        regionId: "",
        type: ""
      },
      columns: [
        { type: "index" },
        {
          label: "姓名",
          prop: "personName"
        },
        {
          label: "身份证号",
          prop: "cardNumber" // sex
        },
        {
          label: "抓拍图",
          slot: "fileUrl"
        },
        {
          label: "出没次数",
          prop: "totalNum"
        }
      ]
    });
    const refData = toRefs(state);
    const tableRef = ref(null);

    const ruleInfo = inject("ruleInfo");
    watchEffect(() => {
      if (ruleInfo.endDate || ruleInfo.startDate) {
        console.log(ruleInfo);
        state.tableParams = { ...state.tableParams, ...ruleInfo };
        state.tableParams.endDate = ruleInfo.endDate;
        state.tableParams.startDate = ruleInfo.startDate;
      }
    });
    return {
      ...refData,
      tableRef,
      queryUserList,
      oftenOut
    };
  }
});
</script>
<style lang="scss" scoped>
.moreDialog {
  height: 60vh;
  .tree-card {
    height: 100%;
    width: 400px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      height: 100%;
      .table-role {
        color: #294a7c;
        cursor: pointer;

        text-align: center;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
  :deep(.el-input__inner) {
    color: var(--el-text-color-regular) !important;
  }
}
</style>
